import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from '../../models/id-name.model';
import { NumberOfFormInstances } from '../../enums/number-of-form-instances.enum';

@Pipe({
  name: 'numberOfFormInstances',
  standalone: false
})
export class NumberOfFormInstancesPipe implements PipeTransform {
  public transform(value: NumberOfFormInstances): string {
    return getNumberOfFormInstances(value);
  }
}

export function getNumberOfFormInstances(value: NumberOfFormInstances): string {
  switch (value) {
    case NumberOfFormInstances.Last5:
      return 'Last 5';
    case NumberOfFormInstances.Last10:
      return 'Last 10';
    case NumberOfFormInstances.Last20:
      return 'Last 20';
    default:
      throw new Error(`Unsupported value for NumberOfFormInstances: ${value}.`);
  }
}

export function getNumberOfFormInstancesList(): IdName[] {
  return enumToList(NumberOfFormInstances, getNumberOfFormInstances);
}
